(function () {
  function rafThrottle(fn){ let id=0,args,ctx; return function(){ args=arguments; ctx=this; if(id) return; id=requestAnimationFrame(()=>{ id=0; fn.apply(ctx,args); }); }; }

  function init(el){
    if(el.getAttribute('data-sticky-initialized') === 'true') return;
    el.setAttribute('data-sticky-initialized','true');

    if(!el.hasAttribute('data-portalized')){
      document.body.appendChild(el);
      el.setAttribute('data-portalized','true');
    }

    el.style.display = '';

    const sectionRoot = document.getElementById(el.getAttribute('data-target-id')) || el.closest('.product-section') || document;
    const mainForm    = document.getElementById(el.getAttribute('data-main-form-id'))
                     || sectionRoot.querySelector('form[id^="AddToCartForm-"]')
                     || sectionRoot.querySelector('form[action="/cart/add"]');
    if(!mainForm) return;

    const behavior   = el.getAttribute('data-behavior') || 'add_to_cart';
    const stickyForm = el.querySelector('form');

    const getVariantIdField = () => mainForm.querySelector('input[name="id"], select[name="id"]');

    function headerOffset(){
      const h = document.querySelector('.amz-sec-hdr') || document.querySelector('.amz-hdr');
      return h ? h.offsetHeight : 0;
    }

    function setBottomOffset(){
  const vv = window.visualViewport;
  let offset = 0;
  if(vv){
    offset = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));
  }
  const prev = parseFloat(el.getAttribute('data-bottom-offset') || '0');
  if (Math.abs(prev - offset) < 2) return;
  el.setAttribute('data-bottom-offset', String(offset));
  el.style.setProperty('--sticky-atc-bottom', offset + 'px');
}


    function setFooterHide(){
      const doc = document.documentElement;
      const scrollTop = window.pageYOffset || doc.scrollTop || 0;
      const viewportH = window.innerHeight || doc.clientHeight || 0;
      const docH = Math.max(doc.scrollHeight, document.body.scrollHeight);
      const progress = docH ? (scrollTop + viewportH) / docH : 0;
      document.documentElement.classList.toggle('scrolled-to-bottom', progress >= 0.9);
    }

    const onScroll = rafThrottle(()=>{
      const rect = mainForm.getBoundingClientRect();
      const hide = rect.top > headerOffset();
      el.classList.toggle('sticky-atc--out', hide);
      setFooterHide();
      setBottomOffset();
    });

    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', onScroll);

    if(window.visualViewport){
      window.visualViewport.addEventListener('scroll', onScroll, {passive:true});
      window.visualViewport.addEventListener('resize', onScroll);
    }

    requestAnimationFrame(onScroll);

    const variantWrap    = el.querySelector('.sticky-atc__details__variant');
    const variantTitleEl = el.querySelector('.sticky-atc__details__variant__title');
    const optionSelects  = Array.from(el.querySelectorAll('.sticky-atc__select'));

    function syncVariantTitle(){
      if(!variantTitleEl) return;
      let txt = '';
      const firstChecked = sectionRoot.querySelector('fieldset.variant-input-wrap input[type="radio"][name]:checked');
      if(firstChecked){ txt = firstChecked.value || ''; }
      else {
        const firstSelect = sectionRoot.querySelector('fieldset.variant-input-wrap select[name]');
        if(firstSelect){
          const opt = firstSelect.options[firstSelect.selectedIndex];
          txt = (opt && opt.text) || firstSelect.value || '';
        }
      }
      variantTitleEl.textContent = txt;
      if(variantWrap) variantWrap.hidden = !txt;
    }

    function syncSelectsFromMain(){
      optionSelects.forEach(sel=>{
        const name = sel.getAttribute('data-option-name');
        const r = sectionRoot.querySelector('fieldset.variant-input-wrap input[type="radio"][name="'+name+'"]:checked');
        if(r){ sel.value = r.value; return; }
        const s = sectionRoot.querySelector('fieldset.variant-input-wrap select[name="'+name+'"]');
        if(s) sel.value = s.value;
      });
    }

    el.addEventListener('change', (e)=>{
      const sel = e.target.closest('.sticky-atc__select'); if(!sel) return;
      const name = sel.getAttribute('data-option-name'); const value = sel.value;

      const radio = sectionRoot.querySelector('fieldset.variant-input-wrap input[type="radio"][name="'+name+'"][value="'+CSS.escape(value)+'"]');
      if(radio){ if(!radio.checked) radio.checked = true; radio.dispatchEvent(new Event('change', {bubbles:true})); }

      const select = sectionRoot.querySelector('fieldset.variant-input-wrap select[name="'+name+'"]');
      if(select){ if(select.value !== value) select.value = value; select.dispatchEvent(new Event('change', {bubbles:true})); }

      burstUpdateImg();
      syncPrices();
      setTimeout(()=>{ syncVariantTitle(); syncSelectsFromMain(); syncPrices(); },0);
    });

    const imgWrap = el.querySelector('.sticky-atc__image');
    let lastSrc = '';

    function parseVariantsCache(){
      const jsonEl = sectionRoot.querySelector('[data-variant-json]');
      if(!jsonEl) return [];
      try { return JSON.parse(jsonEl.textContent || jsonEl.innerHTML || '[]') || []; }
      catch(_){ return []; }
    }

    const variantsCache = parseVariantsCache();

    function findVariantById(id){
      if(!id) return null;
      return variantsCache.find(v=>String(v.id) === String(id)) || null;
    }

    function selectedOptionsFromMain(){
      const selected = [];
      sectionRoot.querySelectorAll('fieldset.variant-input-wrap').forEach(fs=>{
        const r = fs.querySelector('input[type="radio"][name]:checked');
        const s = fs.querySelector('select[name]');
        const val = r ? r.value : (s ? s.value : '');
        if(val) selected.push(val);
      });
      return selected;
    }

    function findVariantByOptions(){
      const selected = selectedOptionsFromMain();
      if(!selected.length || !variantsCache.length) return null;
      return variantsCache.find(v=>{
        if(selected[0] && v.option1 !== selected[0]) return false;
        if(selected[1] && v.option2 !== selected[1]) return false;
        if(selected[2] && v.option3 !== selected[2]) return false;
        return true;
      }) || null;
    }

    function getSelectedVariant(){
      const idField = getVariantIdField();
      if(idField && idField.value){
        const byId = findVariantById(idField.value);
        if(byId) return byId;
      }
      return findVariantByOptions();
    }

    const stickyComparePrice = el.querySelector('.sticky-atc__price--compare');
    const stickyCurrentPrice = el.querySelector('.sticky-atc__price--current');
    const moneyTemplate = el.getAttribute('data-money-format') || '€{{amount_with_comma_separator}}';

    function formatMoney(cents){
      const value = Number(cents);
      if(!Number.isFinite(value)) return '';
      const formats = {
        amount: [2, ',', '.'],
        amount_no_decimals: [0, ',', '.'],
        amount_with_comma_separator: [2, '.', ','],
        amount_no_decimals_with_comma_separator: [0, '.', ','],
        amount_with_apostrophe_separator: [2, "'", '.'],
        amount_with_space_separator: [2, ' ', ',']
      };
      return moneyTemplate.replace(/\{\{\s*(\w+)\s*\}\}/g, (_match, token)=>{
        const [digits, thousands, decimal] = formats[token] || formats.amount_with_comma_separator;
        const parts = (value / 100).toFixed(digits).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        return parts.join(decimal);
      });
    }

    function syncPrices(variant){
      if(!stickyCurrentPrice || !stickyComparePrice) return;
      const selected = (variant && variant.id && (findVariantById(variant.id) || variant))
                    || findVariantByOptions()
                    || getSelectedVariant();
      if(!selected) return;
      const price = Number(selected.price);
      const comparePrice = Number(selected.compare_at_price) || 0;
      if(!Number.isFinite(price)) return;
      const onSale = comparePrice > price;
      stickyCurrentPrice.textContent = formatMoney(price);
      stickyCurrentPrice.classList.toggle('is-sale', onSale);
      stickyComparePrice.hidden = !onSale;
      stickyComparePrice.textContent = onSale ? formatMoney(comparePrice) : '';
    }

    function getVariantImageSrc(variant){
      if(!variant) return '';
      if(variant.featured_image){
        if(typeof variant.featured_image === 'string') return variant.featured_image;
        if(variant.featured_image.src) return variant.featured_image.src;
      }
      if(variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) return variant.featured_media.preview_image.src;
      if(variant.image){
        if(typeof variant.image === 'string') return variant.image;
        if(variant.image.src) return variant.image.src;
      }
      return '';
    }

    function getVariantImageAlt(variant){
      if(!variant) return '';
      if(variant.featured_image && typeof variant.featured_image !== 'string' && variant.featured_image.alt) return variant.featured_image.alt;
      if(variant.featured_media && variant.featured_media.alt) return variant.featured_media.alt;
      if(variant.title) return variant.title;
      return '';
    }

    function getFallbackMainImg(){
      const sels = [
        '.product__main-photos .product-main-slide.is-selected picture img',
        '.product__main-photos .product-main-slide.is-selected img',
        '.product__main-photos [aria-hidden="false"] img',
        '.product__main-photos img',
        '.product__photos img',
        '[data-product-single-media-wrapper][aria-hidden="false"] img',
        '[data-product-single-media-wrapper] img'
      ];
      for(const s of sels){
        const node = sectionRoot.querySelector(s);
        if(node && (node.currentSrc || node.src)) return node;
      }
      return null;
    }

    function normalizeSrc(src){
      if(!src) return '';
      if(src.indexOf('//') === 0) return window.location.protocol + src;
      return src;
    }

    const updateImg = rafThrottle((variant)=>{
      if(!imgWrap) return;
      const selectedVariant = variant || getSelectedVariant();
      const fallbackImg = getFallbackMainImg();
      const newSrc = normalizeSrc(getVariantImageSrc(selectedVariant) || (!lastSrc && fallbackImg && (fallbackImg.currentSrc || fallbackImg.src)) || '');
      if(!newSrc || newSrc === lastSrc) return;

      let stickyImg = imgWrap.querySelector('img');
      if(!stickyImg){
        stickyImg = document.createElement('img');
        stickyImg.loading = 'lazy';
        if('decoding' in stickyImg) stickyImg.decoding = 'async';
        imgWrap.innerHTML = '';
        imgWrap.appendChild(stickyImg);
      }
      stickyImg.alt = getVariantImageAlt(selectedVariant) || (fallbackImg && fallbackImg.alt) || '';
      stickyImg.src = newSrc;
      lastSrc = newSrc;
    });

    function burstUpdateImg(variant){
      updateImg(variant);
      setTimeout(()=>updateImg(variant), 60);
      setTimeout(()=>updateImg(variant), 150);
      setTimeout(()=>updateImg(variant), 300);
    }

    mainForm.addEventListener('change', (e)=>{
      if(e.target && (e.target.name === 'id' || e.target.closest('fieldset.variant-input-wrap'))){
        setTimeout(()=>{ burstUpdateImg(getSelectedVariant()); syncPrices(); }, 0);
      }
    });

    sectionRoot.addEventListener('variantChange', (e)=>{
      const variant = e && e.detail && e.detail.variant ? e.detail.variant : getSelectedVariant();
      burstUpdateImg(variant);
      syncPrices(variant);
    });

    document.addEventListener('variant:change', (e)=>{
      if(e && e.detail && e.detail.sectionId){
        const thisId = sectionRoot.getAttribute('data-section-id') || sectionRoot.dataset.sectionId;
        if(thisId && String(e.detail.sectionId) !== String(thisId)) return;
      }
      const variant = e && e.detail && e.detail.variant ? e.detail.variant : getSelectedVariant();
      burstUpdateImg(variant);
      syncPrices(variant);
    });

    function submitMain(variantId){
      let idField = getVariantIdField();
      if(!idField){ idField = document.createElement('input'); idField.type='hidden'; idField.name='id'; mainForm.appendChild(idField); }
      if(variantId) idField.value = String(variantId);

      const btn = mainForm.querySelector('button[name="add"]');
      if(typeof mainForm.requestSubmit === 'function'){
        try{ if(btn) btn.disabled=false; mainForm.requestSubmit(btn||null); }
        catch(_){ btn ? btn.click() : mainForm.submit(); }
      } else if(btn){ btn.click(); } else { mainForm.submit(); }

      setTimeout(()=>{
        const html = document.documentElement;
        const drawer = document.getElementById('CartDrawer') || document.querySelector('[id*="CartDrawer"]');
        const isOpen = html.classList.contains('js-drawer-open') || drawer?.classList.contains('is-open') || drawer?.getAttribute('aria-hidden')==='false';
        if(!isOpen && drawer){ drawer.classList.add('is-open'); html.classList.add('js-drawer-open','js-drawer-open-right'); }
      },800);
    }

    function findSelectedVariantId(){
      const idField = getVariantIdField();
      if(idField && idField.value) return String(idField.value);
      const v = findVariantByOptions();
      return v ? String(v.id) : '';
    }

    function onStickySubmit(e){
      if(behavior === 'scroll') return;
      e.preventDefault();

      const vid = findSelectedVariantId();
      if(!vid){ mainForm.scrollIntoView({behavior:'smooth', block:'start'}); return; }
      submitMain(vid);
    }

    if(stickyForm) stickyForm.addEventListener('submit', onStickySubmit);

    syncVariantTitle();
    syncSelectsFromMain();
    syncPrices();
    burstUpdateImg();
    setBottomOffset();
    setFooterHide();
  }

  function initAll(){ document.querySelectorAll('sticky-atc').forEach(init); }
  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
